module.exports = __webpack_public_path__ + "img/location_example_fr.4e241ac2.jpg";